export default __webpack_public_path__ + "static/O0288-9ac7c4f4fb160ee8c1dca05d93ceb689.png";